export enum ActionType {
  Nav = 'nav',
  Cta = 'cta',
  Button = 'button',
  Link = 'link',
  Download = 'download',
  Layer = 'layer',
}
